export const IMAGE_PATHS = {
  PRODUCTS: 'products',
  CATERING: 'products',
  RECIPES: 'recipes'
};
